module.exports = __webpack_public_path__ + "media/crypto/usdc-8cbf5867.png";